import { Grid2Props } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';

export const GridChild = ({ lg, md = 6, xs = 12, children, ...props }: Grid2Props) => {
    return (
        <Grid2 lg={lg} md={md} xs={xs} {...props}>
            {children}
        </Grid2>
    );
};
